<!-- App Page not found component -->
<script>
export default {
  name: "app-not-authorized",
};
</script>

<!-- Template -->
<template>
  <div class="not-authorized container-fluid bg-white">
    <div class="row">
      <div class="col-md-12 text-center pl-0 pr-0">
        <img src="../../../../assets/img/lock.png" class="img-fluid mt-5" />
        <h4 class="text-center">Whoops.Authentication Error</h4>
        <P class="text-center"
          >if the problem still continues and you think therw`s something wrong,
          please report to us and we`ll look into it</P
        >
        <router-link v-bind:to="'/'" class="btn btn-primary backBtnErrorPage"
          ><a>Back to Home Page</a></router-link
        >
        <!--<button class="btn btn-primary backBtnErrorPage ">Back to Home Page</button>-->
      </div>
    </div>
  </div>
</template>

<!-- Style -->
<style lang="scss" scoped>
.not-authorized h4 {
  text-align: center;
  margin-top: 24px;
  font-weight: 500;
}

.not-authorized p {
  color: #888888;
}

.backBtnErrorPage {
  background-color: #3cc8a2 !important;
  color: white !important;
  border: none !important;
  text-align: center !important;
  width: 264px;
}

.not-authorized {
  background-image: url("../../../../assets/img/wave.png");
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: contain;
  height: 650px;
}
</style>

